import { Component, Injector, OnInit } from '@angular/core';

import {
  StepData
} from 'models';
import { debounceTime, filter, first } from 'rxjs/operators';

import { ProcessStepBaseComponent } from '../../_core/process-step-base.component';

@Component({
  selector: 'sb-step-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent extends ProcessStepBaseComponent implements OnInit {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    // super.shouldShowBackButton();
    super.isStickyNavigation();
    super.setFormGroup(this.formsService.generateStepCouponCode());
    super.setFormStoreDataFunction(this.appStoreFacadeService.step.storeStepCouponValue);
    this.getFormDataAndValidation();
  }

  public goToPreviousStep() {
    // Overrides because it should redirect to another place, instead of the previous step.
    this.appStoreFacadeService.navigation.goPrevious();
  }

  private getFormDataAndValidation() {
    this.subscriptions.add(
      this.appStoreFacadeService.step.coupon$
        .subscribe((stepData: StepData) => {
          super.setFormGroupStepData(stepData);
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.couponValue$
        .pipe(debounceTime(150), first(Boolean))
        .subscribe(() => {
          this.sendAnalyticsData();
          this.analyticsService.sendCustomPage('/checkout/coupon' );
        })
    );
  }
}
